import type { BaseModalProps } from '@byecode/ui'
import { DesktopModal, Modal } from '@byecode/ui'
import React from 'react'

import ErnieBotAccount from './ErnieBotAccount'

interface ErnieBotAccountModalProps extends BaseModalProps {}

export const ErnieBotAccountModal: React.FunctionComponent<ErnieBotAccountModalProps> = ({ ...rest }) => {
    return (
        <DesktopModal
            width={676}
            {...rest}
            styles={{
                modal: {
                    maxHeight: 'calc(100% - 48px)'
                },
                body: {
                    padding: '0!important'
                },
                header: {
                    borderStyle: 'none'
                }
            }}
        >
            <ErnieBotAccount onClose={rest.onClose} />
        </DesktopModal>
    )
}
